import { render } from "./noticeDetails.vue?vue&type=template&id=df4c8b64&scoped=true"
import script from "./noticeDetails.vue?vue&type=script&lang=js"
export * from "./noticeDetails.vue?vue&type=script&lang=js"

import "./noticeDetails.vue?vue&type=style&index=0&id=df4c8b64&scoped=true&lang=css"
import "./noticeDetails.vue?vue&type=style&index=1&id=df4c8b64&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4c8b64"]])

export default __exports__